import CardBody from 'components/Card/CardBody';
import { HeadingMBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import DetailsRow from './DetailsRow';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Card from 'components/Card/Card';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IContactInformationProps {
	account: types.organizations.IAccount;
}

const ContactInformation = ({ account }: IContactInformationProps) => {
	const classes = useStyles();

	return (
		<Card>
			<CardBody className={classes.additionalInfo}>
				<HeadingMBold color="primary-light">{translate('account.details.contact.information')}</HeadingMBold>
				<DetailsRow label={translate('email.address')} value={account.accountDetails.email} />
				<DetailsRow label={translate('contact.number')} value={account.accountDetails.contactNumber} />
				<ConditionalRender show={!!account.accountDetails.contactNumber2}>
					<DetailsRow label={translate('contact.number')} value={account.accountDetails.contactNumber2} />
				</ConditionalRender>
				<ConditionalRender show={!!account.accountDetails.contactNumber3}>
					<DetailsRow label={translate('contact.number')} value={account.accountDetails.contactNumber3} />
				</ConditionalRender>
			</CardBody>
		</Card>
	);
};

export default ContactInformation;
